import { PlayoutService } from './../../../services/playout.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Playout } from 'app/interfaces/playout';

@Component({
	selector: 'playout-details-start-endscreen',
	templateUrl: './playout-details-start-endscreen.component.html',
	styleUrls: ['./playout-details-start-endscreen.component.scss'],
})
export class PlayoutDetailsStartEndscreenComponent implements OnInit, OnDestroy {
	@Input() playout: Playout;
	@Input() form: NgForm;
	@Input() previewPlayer: any;

	constructor(public playoutService: PlayoutService) {}

	ngOnInit() {}

	ngOnDestroy() {}

	log(a: any) {
		console.warn('log', a);
	}

	unlinkPauseHoverStates() {
		this.playout.linkPauseHoverStates = 'false';
		this.previewPlayer.updatePlayout({linkPauseHoverStates: 'false'});
	}
}
